import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { getToolById } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface ToolsDetailsNCFileTimelineProps {
}

const ToolsDetailsNCFileTimelineComponent: FC<ToolsDetailsNCFileTimelineProps> = ({ getToolById, updateHeaderConfig, getNCFileById }) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: false,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileTimeline = connect(null, {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileTimelineComponent);

export { ToolsDetailsNCFileTimeline };
